import { ANNUAL_INCOME_FEATURE_NAME, ANNUAL_INCOME_FEATURE_VARIANT, ENROLLMENT_FEATURES } from '../../common/constants';

function getEnrollmentFeature(wallet) {
  const targetFeature = wallet.features?.features?.find(f => f.n === ENROLLMENT_FEATURES.PwGBPlus);
  return targetFeature;
}

export function getProgramFromWallet(wallet) {
  const programFeature = getEnrollmentFeature(wallet);
  return programFeature?.p?.program;
}

export function getAnnualIncomeFeatureVariantFromWallet(wallet) {
  const targetFeature = wallet.features?.features?.find(f => f.n === ANNUAL_INCOME_FEATURE_NAME);
  return targetFeature?.v || ANNUAL_INCOME_FEATURE_VARIANT.CHECKBOX;
}
